<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>Guidance</md-icon>
          </div>
          <h4 class="title">Add Guidances : {{ user_department.name }} : {{ new Date() }}</h4>
        </md-card-header>
        <form @submit.prevent="add">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>


            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Department
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="user_department.name" readonly="readonly"/>
                  <validation-error :errors="apiValidationErrors.user_department"/>
                </md-field>
              </div>
            </div>

            <select-input-horizontal
                v-model="guidance.port_id"
                :options="available_departments_dropdown"
                placeholder="Select Port"
                open-direction="above"
                label="Port"
                name="name"
                track-by="id"
                main-class="md-select"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.port_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="guidance.vendor_id"
                :options="vendors"
                placeholder="Select Vendor"
                label="Vendor"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                :append-to-body="true"
                deselect-label="Can't remove"
                label-class="md-select"
                :error="apiValidationErrors.vendor_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="guidance.guidance_type"
                :options="types"
                placeholder="Select Guidance Type"
                label="Guidance Type"
                name="name"
                track-by="name"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.guidance_type"
            ></select-input-horizontal>
            <select-input-horizontal
                v-if="guidance.guidance_type==='Per Work Done'"
                v-model="guidance.pay_code"
                :options="codes"
                placeholder="Select Charging Unit"
                label="Charging Unit"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.pay_code"
            ></select-input-horizontal>
            <select-input-horizontal
                v-model="guidance.duration"
                :options="durations"
                placeholder="Select Duration"
                label="Duration"
                name="name"
                track-by="name"
                main-class="md-layout"
                :allow-empty="false"
                :append-to-body="true"
                deselect-label="Can't remove"
                label-class="md-select"
                :error="apiValidationErrors.duration"
            ></select-input-horizontal>
            <div v-if="guidance.duration">
              <div v-if="guidance.duration !== 'Month'">
                <div class="md-layout" v-if="guidance.duration !== 'Month'">
                  <label class="md-layout-item md-size-25 md-form-label">
                    Start Date
                  </label>
                  <div class="md-layout-item">
                    <md-datepicker
                        v-model="guidance.start_date"
                        md-immediately
                        :md-model-type="String"
                        :md-disabled-dates="disabledStartDates"
                        :class="{ 'md-invalid': !!apiValidationErrors.start_date }"
                    >
                      <label>Select date ...</label>
                      <validation-error :errors="apiValidationErrors.start_date"/>
                    </md-datepicker>
                  </div>
                </div>

                <div class="md-layout" v-if="guidance.duration !=='Day'">
                  <label class="md-layout-item md-size-25 md-form-label">
                    End Date
                  </label>
                  <div class="md-layout-item">
                    <md-datepicker
                        v-model="guidance.end_date"
                        :md-model-type="String"
                        :md-disabled-dates="setEndDateDisable"
                        :class="{ 'md-invalid': !apiValidationErrors.end_date }">
                      <label>Select date ...</label>
                      <validation-error :errors="apiValidationErrors.end_date"/>
                    </md-datepicker>
                  </div>
                </div>
              </div>
              <div v-else>
                <select-input-horizontal
                    v-model="selected_month"
                    :options="months"
                    placeholder="Select Guidance Type"
                    label="Guidance Month"
                    name="name"
                    track-by="id"
                    main-class="md-layout"
                    label-class="md-layout-item md-size-25 md-form-label"
                    :error="apiValidationErrors.start_date"
                    @select="monthDates"
                ></select-input-horizontal>

              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Description
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="guidance.name"/>
                </md-field>
                <validation-error :errors="apiValidationErrors.name"/>
              </div>
            </div>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success" :disabled="submitting">
              <md-progress-spinner v-if="submitting"
                                   class="md-success"
                                   :md-diameter="30"
                                   md-mode="indeterminate"></md-progress-spinner>
              Add Guidance
            </md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
// import Multiselect from 'vue-multiselect'
import SelectInputHorizontal from '../../../components/Inputs/SelectInputHorizontal';
import Vuex from 'vuex';
// import SelectInput from "@/components/Inputs/SelectInput.vue";

// register globally

export default {
    components: { ValidationError, SelectInputHorizontal },

    mixins: [formMixin],

    data: () => ({
        submitting: false,
      selectedPort:{},
        guidanceData: {},
        guidance: {
            type: 'guidances',
            name: null,
            duration: null,
            guidance_type: null,
            start_date: new Date(),
            end_date: null,
            vendor_id: null,
            pay_code: null,
            department_id: { id: null, name: '' },
            options: []
        },
        vendors: [],
        available_departments_dropdown: [],
        durations: [
            { id: 'Day', 'name': 'Day' },
            { id: 'Week', 'name': 'Week' },
            { id: 'Month', 'name': 'Month' },
            { id: 'Custom', 'name': 'Custom' }
        ],
        types: [
            { id: 'Per Man Hour', 'name': 'Per Man Hour' },
            { id: 'Per Work Done', 'name': 'Per Work Done' }
        ],
      codes: [
            { id: 'PT', 'name': 'Per Tonnage (PT)' },
            { id: 'PU', 'name': 'Per Unit (PU)' },
            { id: 'TU', 'name': 'Per TEUs (TU)' }
        ],
        user_department: {},
        months: [],
        selected_month: {},
        monthsName: ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'],
        isDepartmentSectionDisabled: false,
        user: {},
        disabledStartDates: date => {
            return date < new Date().setHours(0, 0, 0, 0);
        },
    }),
    created () {
        this.getMonths();
      //  this.fetchvendors();
        this.getDepartmentDropDowns();
    },


    methods: {
        // async fetchvendors () {
        //     await this.$store.dispatch('vendors/list');
        //     this.vendors = this.$store.getters['vendors/dropdown'];
        //     if (this.vendors && this.vendors.length == 1) {
        //         this.guidance.vendor_id = this.vendors[0].id;
        //     }
        // },
      async fetchVendors() {

        console.log('selectedPort', this.selectedPort);

        let params = {
          filter: {
            station: this.selectedPort?this.selectedPort.station_id:null
          }
        };

        console.log('params', params);

        await this.$store.dispatch('vendors/list', params);

        console.log(
            'vendors dropdown',
            this.$store.getters['vendors/dropdown']
        );

        this.vendors =
            this.$store.getters['vendors/dropdown'];
        console.log(this.vendors);
        console.log("Samia");
      },
        setEndDateDisable (date) {
            return date < new Date(this.guidance.start_date).setHours(0, 0, 0, 0);
        },
      getMonths () {
        let diff = 0;
        const months = [];
        while (diff <= 3) {
          const dateStart = new Date();
          dateStart.setDate(1);

          let newDate = new Date(dateStart.setMonth(dateStart.getMonth() + diff));
          let obj = {
            start_date: new Date(newDate.getFullYear(), newDate.getMonth(), 1),
            end_date: new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0),
            name: this.monthsName[newDate.getMonth()] + ' ' + newDate.getFullYear(),
            id: newDate.getMonth()
          };
          months.push(obj);
          diff++;
        }
        this.months = months;
      },
        validate () {
            let valid = true;
            if (this.guidance.start_date == null) {
                this.apiValidationErrors.start_date = 'Required Field';
                this.notifyError('start date required');
                valid = false;
            }
            if (this.guidance.end_date === null) {
                this.apiValidationErrors.end_date = [];
                this.apiValidationErrors.end_date.push('Provide end data');
                this.notifyError('end date required');
                valid = false;
            }
            if (this.guidance.name === null) {
                this.apiValidationErrors.name = [];
                this.apiValidationErrors.name.push('Provide guidance name');
                this.notifyError('Provide guidance name');
                valid = false;
            }
            console.log(this.apiValidationErrors);
            return valid;
        },
        async add () {
            if (!this.validate()) {
                return;
            }
            this.submitting = true;
            console.log(this.guidance);
            if (typeof this.guidance.start_date === 'object') {
                let start = this.guidance.start_date;
                this.guidance.start_date = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
            }
            if (typeof this.guidance.end_date === 'object') {
                let end = this.guidance.end_date;
                this.guidance.end_date = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();
            }


            try {
                await this.$store.dispatch('guidances/add', this.guidance);
                let guidance = this.$store.getters['guidances/guidance'];
                this.notifySuccess('Guidance added successfully.');
                if(guidance.guidance_type==='Per Man Hour') {
                  this.goManageItem(guidance.id);
                }else{
                  this.goView(guidance.id);
                }
                this.submitting = false;
            } catch (e) {
                this.submitting = false;
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                    console.log(this.apiValidationErrors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getDepartmentDropDowns () {
            let portParams = { filter: { 'station': '' } };
            let station = this.user_department ? this.user_department.station : null;
            if (typeof station !== 'undefined' && station != null) {
                portParams.filter.station = station.id;
            } else {
                portParams = null;
            }
            this.$store.dispatch('ports/list', portParams).then(() => {
                this.available_departments_dropdown = this.$store.getters['ports/dropdown'];
                if (this.available_departments_dropdown && this.available_departments_dropdown.length) {
                    // todo set user port as default
                    // check for station in user department
                    if (typeof this.user_department.port !== 'undefined') {
                        this.guidance.port_id = this.user_department.port.id;
                    }
                    // this.guidance.options = this.available_departments_dropdown[0].id;
                } else {
                    this.notifyError('Fail to load port list');
                }
            });
        },
        monthDates (value) {
            this.guidance.start_date = value.start_date;
            this.guidance.end_date = value.end_date;
        },
        goBack () {
            this.$router.push({ name: 'Guidances List' });
        },
        goView (id) {
            this.$router.push({ name: 'View Guidance', params: { id } });
        },
        goManageItem (id) {
            this.$router.push({ name: 'Manage Guidance Item', params: { id } });
        },
    },
    computed: {
        ...Vuex.mapState({
            me: state => state.profile.me
        }),
        startDate () {
            return this.guidance.start_date;
        },
        endDate () {
            return this.guidance.end_date;
        },
        duration () {
            return this.guidance.duration;
        }
    },
    watch: {
        me: {
            handler: function (val) {
                if (val != null) {
                    this.user_department = val.model.department;
                    this.getDepartmentDropDowns();
                }
            },
            deep: true,
            immediate: true,
        },
        startDate () {
            if (this.guidance.start_date > this.guidance.end_date) {
                delete this.guidance.end_date;
            }
            if (this.guidance.duration === 'Day') {
                this.guidance.end_date = this.guidance.start_date;
            }
        },
        duration () {
            if (this.guidance.duration === 'Day') {
                this.guidance.start_date = new Date();
                this.guidance.end_date = new Date();
            } else if (this.guidance.duration === 'Month') {
                let newDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
                this.selected_month = newDate.getMonth();
                this.guidance.start_date = this.months[1].start_date;
                this.guidance.end_date = this.months[1].end_date;
            }
        },
        endDate () {
            if (this.guidance.duration === 'Day' && this.guidance.start_date !== this.guidance.end_date) {
                this.guidance.start_date = this.guidance.end_date;
            }
        },
        user_department () {
            if (this.user_department != null && this.user_department !== 'undefined') {
                this.guidance.department_id = this.user_department;
                this.isDepartmentSectionDisabled = true;
            } else {
                this.isDepartmentSectionDisabled = false;
            }
        },
      async 'guidance.port_id'(portId) {

        console.log('PORT ID CHANGED', portId);

        if (!portId) {
          this.vendors = [];
          this.guidance.vendor = null;
          return;
        }

        const selectedPort =
            this.available_departments_dropdown.find(
                p => String(p.id) === String(portId)
            );

        console.log('SELECTED PORT', selectedPort);

        this.selectedPort = selectedPort;

        await this.fetchVendors();
      }
    }
};
</script>
